module.exports = __webpack_public_path__ + "img/cube-white.7b700cd3.svg";